import React, { useContext } from 'react';
import AppContext from './context/AppContext';
import useDynamicPath from '../hooks/useDynamicPath';
import constants from '../constants.json' assert { type: 'json' };

const HomeCategories = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    return (
        <div
            className={'mt-4'}>
            <h4
                style={{
                    background: '#f2f2f2'
                }}
                className={'p-2'}>Top Categories</h4>
            <div
                className={'d-flex flex-wrap justify-content-center gap-2'}>
                {appConfig.topCategories.map((category) => (
                    <div
                        key={category.title}>
                        <a
                            href={`${collectionPath[0].pathBeforeParams}/${category.path}`}
                            className={'custom-link d-flex flex-column'}>
                            <img
                                src={category.imageUrl}
                                alt={category.title}
                                className={'w-100 h-100'}
                            />
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomeCategories;